/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';
import { ArrowDownIcon } from './ArrowDownIcon';

const ArrowUpSvg = () => (
  <ArrowDownIcon style={{ transform: 'rotate(180deg)' }} />
);

export const ArrowUpIcon = props => <Icon component={ArrowUpSvg} {...props} />;
